export { FacilitiesConnected as Facilities } from './container';
